module.exports = __webpack_public_path__ + "img/zenmem.da4e48ae.png";